import { call, take } from 'redux-saga/effects'

export function watch(actionType, sagaToCall) {
  return function*() {
    while (true) {
      const actionData = yield take(actionType)
      yield call(sagaToCall, actionData)
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/sagaUtils.js